import PropTypes from "prop-types";

export const propTypes = {
    value: PropTypes.number.isRequired,
};
